<mat-progress-bar [mode]="'indeterminate'" *ngIf="loading"></mat-progress-bar>
<div id="viewer" #viewer></div>